import { render, staticRenderFns } from "./data-table-chart.vue?vue&type=template&id=93376f62&scoped=true&lang=pug&"
import script from "./data-table-chart.vue?vue&type=script&lang=ts&"
export * from "./data-table-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93376f62",
  null
  
)

export default component.exports